import { RouterProvider } from '@tanstack/react-router'
import { router } from '../../router'

export const withRouterProvider = () => {
    const RouterProviderWrapper = () => <RouterProvider router={router} />
    RouterProviderWrapper.displayName = 'RouterProviderWrapper'

    return RouterProviderWrapper
}
